import React from 'react'
import { ButtonGroupProps } from 'react-multi-carousel'

import LeftArrow from '../../images/transition-arrow-left.svg'
import RightArrow from '../../images/transition-arrow-right.svg'
import './common.less'

const CarouselButtonGroup: React.FC<ButtonGroupProps> = ({ next, previous }) => {
  return (
    <>
      <button className="carousel__arrow carousel__arrow--left" onClick={previous}>
        <img src={LeftArrow} />
      </button>
      <button className="carousel__arrow carousel__arrow--right" onClick={next}>
        <img src={RightArrow} />
      </button>
    </>
  )
}

export default CarouselButtonGroup
